// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { StyledButton } from "@insite/mobius/Clickable";
import { productGridContainerStyle } from "@vanmeter/App/Components/Product/ProductGridContainer";
import { css } from "styled-components";

productGridContainerStyle.container = {
    css: css`
        display: grid;
        grid-template-rows: subgrid;
        grid-row: span 10;
        width: 317px;
        position: relative;
        border-radius: 0;
        background-color: transparent;
        box-shadow: none;
        box-sizing: border-box;
    `,
};

productGridContainerStyle.image = {
    css: css`
        display: flex;
        justify-content: center;
        position: relative;
        height: 100%;
        width: 100%;
        margin: 0 auto;
        padding-bottom: 8px;
        ${StyledButton} {
            min-width: 150px;
            max-width: 150px;
            min-height: 150px;
            max-height: 150px;
            img {
                max-width: 100%;
                max-height: 100%;
                height: auto;
            }
        }
    `,
};

productGridContainerStyle.title = {
    css: css`
        margin-bottom: 4px;
        &:empty {
            margin-bottom: 0;
        }
    `,
};

productGridContainerStyle.description = {
    css: css`
        margin-bottom: 8px;
        &:empty {
            margin-bottom: 0;
        }
    `,
};

productGridContainerStyle.partNumbers = {
    css: css`
        margin-bottom: 8px;
        &:empty {
            margin-bottom: 0;
        }
    `,
};

productGridContainerStyle.availability = {
    css: css`
        margin-bottom: 8px;
        &:empty {
            margin-bottom: 0;
        }
    `,
};

productGridContainerStyle.badges = {
    css: css`
        margin-bottom: 8px;
        &:empty {
            margin-bottom: 0;
        }
    `,
};

productGridContainerStyle.price = {
    css: css`
        margin-bottom: 8px;
        &:empty {
            margin-bottom: 0;
        }
    `,
};

productGridContainerStyle.addToCartActions = {
    css: css``,
};

productGridContainerStyle.addToList = {
    css: css`
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin-top: 12px;
        &:empty {
            margin-top: 0;
        }
    `,
};
